import { render, staticRenderFns } from "./CustomColumnValues.vue?vue&type=template&id=6ac7796d&scoped=true"
import script from "./CustomColumnValues.vue?vue&type=script&lang=ts"
export * from "./CustomColumnValues.vue?vue&type=script&lang=ts"
import style0 from "./CustomColumnValues.vue?vue&type=style&index=0&id=6ac7796d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac7796d",
  null
  
)

export default component.exports